export enum SubscriptionStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  EXPIRED = "EXPIRED",
  CANCELLED = "CANCELLED",
  PAST_DUE = "PAST_DUE",
  TRIAL = "TRIAL",
}

export enum PaymentMethod {
  CARD = "CARD",
  MOBILE_MONEY = "MOBILE_MONEY",
}

export enum PaymentProvider {
  STRIPE = "STRIPE",
  PAYSTACK = "PAYSTACK",
  FLUTTERWAVE = "FLUTTERWAVE",
  MTN_MOMO = "MTN_MOMO",
  AIRTEL_MONEY = "AIRTEL_MONEY",
}
